import axios from 'axios'
import _this from '../main'
import { showLoading, hideLoading } from './loading';
import { Message } from 'element-ui';

axios.defaults.timeout = 60*1000*60;                        //响应时间 60分钟
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';        //配置请求头
if (process.env.NODE_ENV === 'development') {
    axios.defaults.baseURL = '/api'; // 配置axios请求的地址
}
axios.withCredentials = true;
axios.interceptors.request.use(function (config) {
    if(config.url=="/map/addmap"||config.url=="/map/updatemap"||config.url=="/componentlist/changecom"){
        showLoading();
    }
    const token = localStorage.getItem('token');    
    token && (config.headers.Authorization = token); 
      return config;
  }, function (error) {
      // 对请求错误做些什么
      return Promise.reject(error);
  });
  
  // 添加响应拦截器
  axios.interceptors.response.use(function (response) {
      
      hideLoading();
      if(response.data.status == "403"){
          Message({
              message: response.data.msg || '登录已过期,请重新登录',
              type: 'error',
              duration: 2000
            })
            localStorage.removeItem('token')
            _this.$router.push({
                name: "login"
            })
        }
      return response;
  }, function (error) {
      // 对响应错误做点什么
      return Promise.reject(error);
  });
export default (url, data,success, fail, method) => {
    axios({
        method: method || 'POST',
        url: url,
        data: data
    }).then((response) => {
        let da = response.data;
        if (response.status == 200 ) {
            success && success(da);
        } else {
            fail && fail(da);
        }
    }).catch((error) => {
        console.error(error);
    })
}


// WEBPACK FOOTER //
// ./src/utils/axios.js